/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReservationStatusRequest
 */
export interface UpdateReservationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationStatusRequest
     */
    status: UpdateReservationStatusRequestStatusEnum;
}


/**
 * @export
 */
export const UpdateReservationStatusRequestStatusEnum = {
    Processing: 'processing',
    Pending: 'pending',
    Confirmed: 'confirmed',
    Ongoing: 'ongoing',
    Cancelled: 'cancelled',
    NoShow: 'no-show',
    Finished: 'finished'
} as const;
export type UpdateReservationStatusRequestStatusEnum = typeof UpdateReservationStatusRequestStatusEnum[keyof typeof UpdateReservationStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateReservationStatusRequest interface.
 */
export function instanceOfUpdateReservationStatusRequest(value: object): value is UpdateReservationStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateReservationStatusRequestFromJSON(json: any): UpdateReservationStatusRequest {
    return UpdateReservationStatusRequestFromJSONTyped(json, false);
}

export function UpdateReservationStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReservationStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function UpdateReservationStatusRequestToJSON(json: any): UpdateReservationStatusRequest {
    return UpdateReservationStatusRequestToJSONTyped(json, false);
}

export function UpdateReservationStatusRequestToJSONTyped(value?: UpdateReservationStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

